export default "__VITE_ASSET__tddEA4l___"